namespace SorAraBul.Membership {
    export interface ProfileUpdateForm {
        MobilePhoneNumber: Common.PhoneEditor;
        InvoiceAddress: Serenity.TextAreaEditor;
    }

    export class ProfileUpdateForm extends Serenity.PrefixedContext {
        static formKey = 'Membership.ProfileUpdate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProfileUpdateForm.init)  {
                ProfileUpdateForm.init = true;

                var s = Serenity;
                var w0 = Common.PhoneEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(ProfileUpdateForm, [
                    'MobilePhoneNumber', w0,
                    'InvoiceAddress', w1
                ]);
            }
        }
    }
}
